// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"897224fe","715":"6fa71497","787":"d16d0675","886":"c7138e01"}[chunkId] + ".chunk.js";
};